// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab4ca6de","455":"970d8d38","977":"f4f6dd43"}[chunkId] + ".chunk.js";
};